import { createReducer } from '@reduxjs/toolkit';

import { StatisticsStorageInit } from 'redux/reducers/init';

import {
  requestStatisticsStorage,
  requestStatisticsStorageSuccess,
  requestStatisticsStorageFailure,
} from 'redux/actions/statistics/actions';

/**
 * Reducers
 */
const statisticsStorage = createReducer(StatisticsStorageInit, {
  [requestStatisticsStorage.type]: (state, action: RequestStatisticsStorageAction) => {
    state.isLoading = true;
  },
  [requestStatisticsStorageSuccess.type]: (
    state,
    action: RequestStatisticsStorageSuccessAction,
  ) => {
    const { statisticsStorage } = action.payload;
    state.isLoading = false;
    state.statistics = statisticsStorage;
  },
  [requestStatisticsStorageFailure.type]: (
    state,
    action: RequestStatisticsStorageFailureAction,
  ) => {
    state.isLoading = false;
    state.statistics = [];
  },
});

export default statisticsStorage;
